<template>
    <span>
        <el-button type="text" @click="dialogFormVisible = true">统计配置<i class="el-icon-setting"></i></el-button>
        <el-dialog title="统计数据配置" :visible.sync="dialogFormVisible" center>
            <el-form ref="form" :model="form" size="small" status-icon label-width="170px">
                <span>屏蔽数据（被屏蔽的有关数据不会参与统计）</span>
                <el-switch v-model="form.is_filter" :active-value="1" :inactive-value="0"></el-switch>
                <el-divider></el-divider>
                <template v-if="form.is_filter"> 
                    <el-form-item label="屏蔽额度版产品：" prop="product_version">
                        <el-switch v-model="form.product_version" :active-value="1" :inactive-value="0"></el-switch>
                        <!-- <el-select v-model="form.product_version" placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="屏蔽产品：" prop="product_ids">
                        <Product v-model="form.product_ids" :product_id="form.product_ids" :multiple="true" :clearable="true" @change="getValue($event, 'product_ids')" style="width:100%;"></Product>
                    </el-form-item>
                    <el-form-item label="屏蔽发票抬头：" prop="taxpayer_ids">
                        <InvoiceSelect v-model="form.taxpayer_ids" :taxpayer_ids="form.taxpayer_ids" @change="getValue($event, 'taxpayer_ids')" style="width:100%;"></InvoiceSelect>
                    </el-form-item>
                </template>
                <br><br>
                <template v-if="type == 'calc'">
                    <span>自定义算法（只计算最早的一个合同上传时间、实际回款时间）</span>
                    <el-divider></el-divider>
                    <el-form-item label="新增业绩：" prop="performance">
                        <CountConfigNode :nodes="form.performance" @change="changeCountConfig($event, 'performance')" key="performance"></CountConfigNode>
                    </el-form-item>
                    <el-form-item label="续费业绩：" prop="renew">
                        <CountConfigNode :nodes="form.renew" @change="changeCountConfig($event, 'renew')" key="renew"></CountConfigNode>
                    </el-form-item>
                    <el-form-item label="代理新增业绩：" prop="proxy_performance">
                        <CountConfigNode :nodes="form.proxy_performance" @change="changeCountConfig($event, 'proxy_performance')" key="proxy_performance"></CountConfigNode>
                    </el-form-item>
                    <el-form-item label="代理续费业绩：" prop="proxy_renew">
                        <CountConfigNode :nodes="form.proxy_renew" @change="changeCountConfig($event, 'proxy_renew')" key="proxy_renew"></CountConfigNode>
                    </el-form-item>
                    <el-form-item label="断续新增业绩：" prop="stop_renew">
                        <CountConfigNode :nodes="form.stop_renew" tooltip_content="断续6-24个月内，由不同人开通新单" @change="changeCountConfig($event, 'stop_renew')" key="stop_renew"></CountConfigNode>
                    </el-form-item>
                </template>
                <template v-else-if="type == 'settle'">
                    <span>结算日期配置（配置后，用于【业绩确认表】应结算月份筛选）</span>
                    <el-divider></el-divider>
                    
                    <div v-for="(item, index) in form.settle" :key="index">
                        <span>{{item.label}}：</span>
                        &nbsp;&nbsp;&nbsp;
                        <el-button type="text" @click="addNode(index)">＋新增</el-button>
                        <el-table width="100%" :data="item.list" :show-header="false" v-if="item.list.length > 0">
                            <el-table-column prop="sign_mode" width="190">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.time_field" size="mini" placeholder="请选择" style="width:120px;">
                                        <el-option label="录单时间" value="create"></el-option>
                                        <el-option label="合同上传时间" value="contract"></el-option>
                                        <el-option label="实际回款时间" value="payment"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sign_mode" width="190">
                                <template slot-scope="scope">
                                    <el-date-picker
                                    size="mini"
                                    type="daterange"
                                    v-model="scope.row.times"
                                    format="dd"
                                    value-format="dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    style="width:180px;">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column width="50">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="deleteNode(index, scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <br>
                    <p style="color:red;">说明：<br>
                    1. 结算日期为8日~7日，表示结算的范围在本月8日~次月7日间，如现在要计算10月业绩，那10月业绩的结算范围为10月8日~11月7日。<br>
                    2. 结算日期为空则表示结算范围为本月，如现在要计算10月业绩，那10月业绩的结算范围为10月1日~10月31日。
                    </p>
                </template>
                <template v-else-if="type == 'area'">
                    <span>选择统计城市（只能选择到城市）</span>
                    <el-divider></el-divider>
                    <el-form-item prop="area_tree">
                        <el-tree
                            ref="areaTree"
                            :data="area_tree"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="form.city_ids"
                            :props="defaultProps"
                            @check="treeCheck"
                            v-loading="loading"
                        >
                        </el-tree>
                    </el-form-item>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')" :loading="loading">保 存</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<style scoped>
/* 仅应用于当前组件的样式 */
</style>
<script>
import CountConfigService from '~/services/CountConfig';
import DistrictService from "~/services/district";
import Product from "~/widgets/Product.vue";
import InvoiceSelect from "~/widgets/InvoiceSelect.vue";
import CountConfigNode from "~/widgets/table/CountConfigNode.vue";
export default {
    name: "CountConfig",
    
    components: {
        Product,
        InvoiceSelect,
        CountConfigNode
    },

    props: {
        path: {
            type: String,
            required: true,
        },
        tab: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            //定义变量
            loading: false,
            dialogFormVisible: false,
            form: {
                is_filter: 0,
                product_version: 0,
                product_ids: [],
                taxpayer_ids: [],
                performance: [],
                renew: [],
                proxy_performance: [],
                proxy_renew: [],
                stop_renew: [],
                city_ids: [],
                path: this.path,
                tab: this.tab,
                settle: [],
            },
            rules: {
                type: [
                    {required: true, message: "请选择发票类型", trigger: "blur"}
                ],
            },
            area_tree: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
        };
    },

    created() {
        this.getView();
        if(this.type == 'area'){
            this.getDistricts();
        }
    },

    methods: {
        getView(){
            CountConfigService.getView({
                path: this.path,
                tab: this.tab,
            }).then(res => {
                if (res.code == 0 && res.data){
                    this.form = Object.assign(this.form, res.data);
                    // console.log('查询结果：', this.form);
                }
            });
        },

        getDistricts(){
            DistrictService.getCityTree().then(res => {
                if (res.code == 0 && res.data){
                    this.area_tree = res.data;
                }
            });
        },
        
        getValue(value, field) {
            this.form[field] = value;
        },

        submitForm(formName){
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    // console.log('submitForm：', this.form, this.form.id ? true : false);
                    let servcie;
                    if(this.form.id){
                        servcie = CountConfigService.update(this.form);
                    }else{
                        servcie = CountConfigService.create(this.form);
                    }
                    servcie.then(res => {
                        if (res.code == 0 && res.data){
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            this.form.id = res.data.id;
                            this.dialogFormVisible = false;
                        }
                        this.loading = false;
                    }).catch((err) => {
                        console.error(err);
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },

        changeCountConfig(value, field){
            this.form[field] = value;
            // console.log('changeCountConfig：', value, field, this.form);
        },

        treeCheck(data, checked, indeterminate){
            this.form.city_ids = checked.checkedKeys;
            // console.log('treeCheck:', data, checked, indeterminate);
        },

        /**
         * 添加节点
         * @param id
         */
        addNode(index){
            this.form.settle[index].list.push(
                {
                    id: this.form.settle[index].list.length + 1,
                    time_field: 'create',
                    times: []
                }
            )
        },

        /**
         * 删除节点
         * @param id
         */
        deleteNode(index, id){
            this.form.settle[index].list = this.form.settle[index].list.filter(function (item) {
                return item.id != id;
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/widgets/CountConfig.vue